import { render } from "./Client.vue?vue&type=template&id=18020618&lang=pug"
import script from "./Client.vue?vue&type=script&lang=js"
export * from "./Client.vue?vue&type=script&lang=js"

import "./Client.vue?vue&type=style&index=0&id=18020618&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__